// Modules
import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';
import { Store, select } from '@ngrx/store';

// Rxjs
import { take } from 'rxjs/operators';

// Constants
import { APP_PATHS_CONSTANTS } from '@shared/constants';

// Store - Reducer
import { AppState } from '@store/reducers';
// Store - Selectors
import * as GeneralSelectors from '@store/selectors/general.selectors';

@Component({
    selector: 'sbi-cot-back-main-top-bar',
    templateUrl: './main-top-bar.component.html',
    styleUrls: ['./main-top-bar.component.scss'],
    standalone: false
})
export class MainTopBarComponent {
  // Public selectors
  public currentPage$ = this._store$.pipe(
    select(GeneralSelectors.selectCurrentPage)
  );

  @Input() topBarName: string = '';

  // Constructor
  constructor(
    private _router: Router,
    private _store$: Store<AppState>
  ) {}

  // Public method to handle icon click
  public onIconClick(): void {
    this.currentPage$.pipe(take(1)).subscribe(val => {
      if (val.activateRoute) {
        this._router.navigateByUrl(
          `${APP_PATHS_CONSTANTS.ADMIN_PRIVATE_WRAPPER}/${val.activateRoute}`
        );
      }
    });
  }
}
